export enum WhatsappCampaignParameterSource {
  FIXED = "FIXED",
  CONTACT_NAME = "CONTACT_NAME",
}
